@if (tour.currentStep(); as step) {
  <div class="tour">
    <!-- The page stays visible but out of reach while the tour runs. -->
    <div class="tour__blocker" [class.tour__blocker--dim]="!spotlight()" aria-hidden="true"></div>
    @if (spotlight(); as rect) {
      <div
        class="tour__spotlight"
        aria-hidden="true"
        [style.top.px]="rect.top"
        [style.left.px]="rect.left"
        [style.width.px]="rect.width"
        [style.height.px]="rect.height"
      ></div>
    }

    <esn-tour-callout
      class="tour__callout"
      [class.tour__callout--centred]="!target()"
      [step]="tour.step() ?? 1"
      [total]="tour.total"
      [heading]="step.heading"
      [body]="step.body"
      [pointer]="target() ? (step.pointer ?? 'none') : 'none'"
      [anchor]="target()"
      [nextLabel]="nextLabel()"
      backLabel="Back"
      [skipLabel]="skipLabel()"
      finishLabel="Create your first island"
      finishIcon="plus"
      (next)="tour.next()"
      (back)="tour.back()"
      (skip)="tour.stop()"
      (finish)="tour.finish()"
    />
  </div>
}
